/**
 * Austausch-Naht für Browser-Fehler-Reporting. Heute leer: Es gibt keinen Live-Fall, der ein
 * Browser-SDK rechtfertigt (das erzeugt einen Event-Strom, den jemand sichten muss).
 * Anschlussbedingung: Am Tag, an dem zum ersten Mal ein Browser-Fehler fehlt, hier das SDK
 * initialisieren (sendDefaultPii aus; leere DSN = deaktiviert). Einziger Aufrufer: ErrorBoundary
 * über App.js. Kein `@sentry/`-Import außerhalb dieser Datei.
 */
export function reportError(error, context) {}
